// extracted by mini-css-extract-plugin
export var actionIcon = "_qz-0";